module.exports = __webpack_public_path__ + "static/img/bug.f34b1328.svg";